import type { PlotSeries } from "@/shared/state/visualization";

import { DataNotFoundMessage } from "../DataNotFoundMessage";

import type { SeriesTruncation } from "./PlotDataStreamer";
import styles from "./PlotPanel.module.css";
import { SeriesTruncationNotice } from "./SeriesTruncationNotice";

interface PlotPanelNoticesProps {
  /** The panel whose layout match failures the data-not-found warning lists. */
  panelId: string;
  /** The series the panel plots, which name the series a truncation is about. */
  series: PlotSeries[];
  /**
   * What the last render reported as drawn only in part. One for a series the
   * panel no longer plots, or no longer plots from that data source, is ignored.
   */
  truncations: SeriesTruncation[];
}

/**
 * The plot panel's warnings along its top edge, stacked in flow so that one
 * never paints over another.
 */
export function PlotPanelNotices({
  panelId,
  series,
  truncations,
}: PlotPanelNoticesProps) {
  return (
    <div className={styles.notices}>
      <DataNotFoundMessage panelId={panelId} placement="inline" />
      <SeriesTruncationNotice series={series} truncations={truncations} />
    </div>
  );
}
